import { Patient } from "../../../api/patient.types";
import { PatientsBymistokenAddedAction } from "./patients.bymistoken.added.types";

export const patientsBymistokenAddedRequest = (): PatientsBymistokenAddedAction => ({ type: 'PATIENTS_BYMISTOKEN_ADDED_REQUEST' })

export const patientsBymistokenAddedSuccess = (users: Patient[]): PatientsBymistokenAddedAction => ({ type: 'PATIENTS_BYMISTOKEN_ADDED_SUCCESS', params: { users } })

export const patientsBymistokenAddedFailure = () => ({ type: 'PATIENTS_BYMISTOKEN_ADDED_FAILURE' } as const)